import React, { useEffect } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { Navbar, Nav, Container, NavDropdown } from 'react-bootstrap';
import { PersonCircle, BoxArrowRight, CreditCard, PlusCircle, Grid3x3GapFill, Gear } from 'react-bootstrap-icons';
import { useAuth } from '../contexts/AuthContext';
import NotificationBell from './NotificationBell';

const AppNavbar: React.FC = () => {
  const { isAuthenticated, user, logout } = useAuth();
  const history = useHistory();
  const location = useLocation();

  const hidden =
    location.pathname === '/' ||
    (!isAuthenticated && ['/login', '/register', '/forgot-password', '/reset-password'].includes(location.pathname));

  // Toggle a body class so CSS can offset ion-router-outlet by the navbar
  // height only when the navbar is actually visible.
  useEffect(() => {
    document.body.classList.toggle('has-app-navbar', !hidden);
    return () => { document.body.classList.remove('has-app-navbar'); };
  }, [hidden]);

  if (hidden) return null;

  const handleLogout = () => {
    logout();
    history.push('/login');
  };

  return (
    <Navbar bg="white" expand="md" sticky="top" className="shadow-sm border-bottom">
      {/* Full width: brand and links hard left, notifications and account hard right. */}
      <Container fluid className="px-3 px-md-4">
        <Navbar.Brand as={Link} to="/dashboard" className="navbar-brand-gradient">
          QA Master
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="main-nav" />
        <Navbar.Collapse id="main-nav">
          {isAuthenticated && (
            <>
              <Nav className="me-auto">
                <Nav.Link
                  as={Link}
                  to="/dashboard"
                  active={location.pathname === '/dashboard'}
                >
                  <Grid3x3GapFill className="me-1" size={14} />
                  Dashboard
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  to="/projects/create"
                  active={location.pathname === '/projects/create'}
                >
                  <PlusCircle className="me-1" size={14} />
                  New Project
                </Nav.Link>
              </Nav>
              <Nav className="align-items-center">
                <div className="me-2">
                  <NotificationBell />
                </div>
                <NavDropdown
                  title={
                    <span>
                      <PersonCircle className="me-1" size={16} />
                      {user?.firstName || 'Account'}
                    </span>
                  }
                  id="user-dropdown"
                  align="end"
                >
                  <NavDropdown.Item as={Link} to="/subscription">
                    <CreditCard className="me-1" size={14} />
                    Subscription
                  </NavDropdown.Item>
                  <NavDropdown.Item as={Link} to="/settings">
                    <Gear className="me-1" size={14} />
                    Settings
                  </NavDropdown.Item>
                  <NavDropdown.Divider />
                  <NavDropdown.Item onClick={handleLogout}>
                    <BoxArrowRight className="me-1" size={14} />
                    Logout
                  </NavDropdown.Item>
                </NavDropdown>
              </Nav>
            </>
          )}
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default AppNavbar;
